import { CfbTeam } from './team';

export class CfbPlayoffTeam {
  Team: CfbTeam;
  Seed: number;
  TeamDisplayName: string;

  constructor(team: CfbTeam, seed: number) {
    if (team) {
      this.Team = new CfbTeam(
        team.TeamAbbreviation,
        team.RegionName,
        team.TeamName,
        team.Conference,
        team.Division,
        team.TeamID,
        team.ProgramName,
        team.TeamLogo,
      );
      this.TeamDisplayName = `${team.TeamName} <sup>${seed}</sup>`;
      this.Seed = seed;
    }
  }
}
